import styles from 'css/src/components/public-pages/SixIcons.module.scss';

import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

import type { ImmutableMap } from 'js/src/libs/consts';

type IconAreaProps = {
    icon: string;
    iconColor: string;
    headline: string;
    paragraph: ImmutableMap<Document>;
};

const IconArea = React.memo(function IconArea({
    icon,
    iconColor,
    headline,
    paragraph,
}: IconAreaProps) {
    let paragraphNode = null;
    if (paragraph) {
        paragraphNode = documentToReactComponents(paragraph.toJS());
    }

    return (
        <div className={`row ${styles['icon-area']}`}>
            <div className="col-lg-1 col-sm-2">
                <i
                    translate="no"
                    className="material-symbols-outlined mt-l5-4"
                    style={{ color: iconColor }}
                >
                    {icon}
                </i>
            </div>
            <div className="col-lg-11 col-sm-10">
                <h4 className="fw-bold">{headline}</h4>
                <div className={`font-l5 font-l5--small ${styles['remove-bottom-margin']}`}>
                    {paragraphNode}
                </div>
            </div>
        </div>
    );
});

const ICON_COLORS = ['#5846F6', '#02D3DA', '#F8558E', '#49D66E', '#FFA101', '#FF4B38'];

type SixIconsProps = {
    data: ImmutableMap<{
        icon1: string;
        headline1: string;
        paragraph1: Document;
        icon2: string;
        headline2: string;
        paragraph2: Document;
        icon3: string;
        headline3: string;
        paragraph3: Document;
        icon4: string;
        headline4: string;
        paragraph4: Document;
        icon5: string;
        headline5: string;
        paragraph5: Document;
        icon6: string;
        headline6: string;
        paragraph6: Document;
    }>;
    bgColor?: string;
};

const SixIcons = React.memo(function SixIcons({ data, bgColor }: SixIconsProps) {
    const iconAreaNodes = [];
    for (let i = 0; i < 6; i++) {
        const icon = data.get(
            `icon${i + 1}` as 'icon1' | 'icon2' | 'icon3' | 'icon4' | 'icon5' | 'icon6',
        );
        const headline = data.get(
            `headline${i + 1}` as
                | 'headline1'
                | 'headline2'
                | 'headline3'
                | 'headline4'
                | 'headline5'
                | 'headline6',
        );
        const paragraph = data.get(
            `paragraph${i + 1}` as
                | 'paragraph1'
                | 'paragraph2'
                | 'paragraph3'
                | 'paragraph4'
                | 'paragraph5'
                | 'paragraph6',
        );
        if (icon && paragraph && headline) {
            iconAreaNodes.push(
                <div className="col-md-6 col-sm-12 my-l5-48" key={headline + icon}>
                    <IconArea
                        icon={icon}
                        iconColor={ICON_COLORS[i]}
                        headline={headline}
                        paragraph={paragraph}
                    />
                </div>,
            );
        }
    }
    return (
        <div
            className={`contentful-component ${styles['six-icons']}`}
            style={{ backgroundColor: bgColor }}
        >
            <div className="container">
                <div className="row">{iconAreaNodes}</div>
            </div>
        </div>
    );
});

export default SixIcons;
